// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".back-button-create-restaurant[data-v-4462e271]{left:1%;position:absolute!important;top:38px}.location-field[data-v-4462e271]{border:1px solid rgba(0,0,0,.38);border-radius:8px!important;margin-bottom:3px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
